import { useOidc } from '@axa-fr/react-oidc';
import React from 'react';
import { Navigate, Outlet } from 'react-router';
import LoadingComponent from '../../loading/LoadingComponent';

const PrivateOutlet = () => {
  const { isAuthenticated, isLoading, error } = useOidc();

  console.log('[PrivateOutlet] State:', { isAuthenticated, isLoading, error });

  if (isLoading) {
    console.log('[PrivateOutlet] Loading...');
    return <LoadingComponent />;
  }

  if (error) {
    console.error('[PrivateOutlet] Authentication error:', error);
    sessionStorage.setItem('authError', JSON.stringify(error));
    return <Navigate to="/auth/error" replace />;
  }

  if (!isAuthenticated) {
    console.log('[PrivateOutlet] Not authenticated, redirecting to login');
    const currentPath = window.location.pathname;
    if (
      currentPath !== '/auth/login' &&
      currentPath !== '/auth/sso' &&
      currentPath !== '/auth/error'
    ) {
      sessionStorage.setItem('redirectPath', currentPath);
    }
    return <Navigate to="/auth/login" replace />;
  }

  console.log('[PrivateOutlet] Authenticated, rendering outlet');
  return <Outlet />;
};

export default PrivateOutlet;
